<input
  type="number"
  style="width: 30%"
  placeholder="{{ 'partition' | translate }}"
  min="0"
  id="{{ data.idcollis }}"
  (input)="getpartitionid(data, $event.target.value)"
  value="{{ data.quantitereste }}"
  max="{{ data.quantitereste }}"
/>
<br />
<ng-container *ngIf="multipleColis">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Position Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>No.</th>
      <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ "nomcollis" | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.toggle(row)"
    ></tr>
  </table>
</ng-container>

<div fxLayout="row-reverse" fxLayoutGap="10px">
  <button mat-raised-button cdkFocusInitial color="primary" (click)="save()">
    <span>{{ "Partitioner" | translate }}</span>
  </button>
  <a (click)="close()" mat-raised-button>{{ "buttons.cancel" | translate }}</a>
</div>
